import React, { useState } from 'react';
import { FaEye, FaArrowLeft, FaUser, FaCopy, FaEdit, FaTrash, FaInfoCircle } from 'react-icons/fa';
import './UserTable.css';

const UserTable = ({ data }) => {
  const [viewMode, setViewMode] = useState('count');
  const [selectedUser, setSelectedUser] = useState(null);
  const [contextMenu, setContextMenu] = useState(null);

  // Handle right-click for context menu
  const handleContextMenu = (e, user) => {
    e.preventDefault();
    setContextMenu({
      x: e.clientX,
      y: e.clientY,
      user
    });
  };

  // Close context menu when clicking elsewhere
  const closeContextMenu = () => {
    setContextMenu(null);
  };

  // Context menu actions
  const contextMenuActions = [
    {
      label: 'Copy User ID',
      icon: <FaCopy size={14} />,
      handler: () => navigator.clipboard.writeText(contextMenu.user.id)
    },
    {
      label: 'Edit User',
      icon: <FaEdit size={14} />,
      handler: () => {
        setSelectedUser(contextMenu.user);
        setViewMode('details');
      }
    },
    {
      label: 'View Details',
      icon: <FaInfoCircle size={14} />,
      handler: () => {
        setSelectedUser(contextMenu.user);
        setViewMode('details');
      }
    }
  ];

  // Enhanced cell formatting
  const formatCellValue = (value, key) => {
    if (value === null || value === undefined) {
      return <span className="null-value">NULL</span>;
    }
    
    if (typeof value === 'boolean') {
      return (
        <span className={`bool-value ${value ? 'true' : 'false'}`}>
          {value ? 'Yes' : 'No'}
        </span>
      );
    }
    
    if (key.toLowerCase().includes('email')) {
      return <span className="email-value">{value}</span>;
    }
    
    if (key.toLowerCase().endsWith('id')) {
      return <span className="id-value">{value}</span>;
    }
    
    if (key.toLowerCase().includes('date') || key === 'createdAt' || key === 'updatedAt') {
      return <span className="date-value">{new Date(value).toLocaleString()}</span>;
    }
    
    return String(value);
  };

  // Format user details for display (using formatCellValue)
  const formatDetail = (key, value) => {
    return formatCellValue(value, key);
  };

  // Add event listener to close context menu
  React.useEffect(() => {
    const handleClick = () => closeContextMenu();
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  if (viewMode === 'count') {
    return (
      <div className="users-count-view">
        <button className="inspect-button"
          onClick={() => setViewMode('list')}
        >
          <div className="count-card">
            <div className="count-icon">
              <FaUser />
            </div>
            <div className="count-value">{data.length}</div>
            <div className="count-label">Total Users</div>
          </div>
        </button>
       
          
        
       
      </div>
    );
  }

  if (viewMode === 'list') {
    return (
      <div className="users-list-view">
        <button 
          className="back-button"
          onClick={() => setViewMode('count')}
        >
          <FaArrowLeft /> Back
        </button>
        <h4>Select a User</h4>
        <div className="user-list">
          {data.map(user => (
            <div 
              key={user.id || user._id}
              className="user-item"
              onClick={() => {
                setSelectedUser(user);
                setViewMode('details');
              }}
              onContextMenu={(e) => handleContextMenu(e, user)}
            >
              {user.name || user.email || `User ${user.id}`}
            </div>
          ))}
        </div>
        
        {contextMenu && (
          <ContextMenu 
            x={contextMenu.x}
            y={contextMenu.y}
            onClose={closeContextMenu}
            actions={contextMenuActions}
          />
        )}
      </div>
    );
  }

  // Details View
  return (
    <div className="user-details-view">
      <button 
        className="back-button"
        onClick={() => setViewMode('list')}
      >
        <FaArrowLeft /> Back to List
      </button>
      
      <h4>User Details</h4>
      
      <div className="details-grid">
        {selectedUser && Object.entries(selectedUser).map(([key, value]) => (
          <div key={key} className="detail-row">
            <div className="detail-key">{key}:</div>
            <div className="detail-value">{formatDetail(key, value)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Context Menu Component (now properly separated)
const ContextMenu = ({ x, y, onClose, actions }) => {
  return (
    <div 
      className="context-menu" 
      style={{ 
        top: `${y}px`, 
        left: `${x}px`,
        position: 'fixed' // Important for proper positioning
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {actions.map((action, index) => (
        <div 
          key={index}
          className="context-menu-item"
          onClick={() => {
            action.handler();
            onClose();
          }}
        >
          {action.icon && <span className="menu-icon">{action.icon}</span>}
          {action.label}
        </div>
      ))}
    </div>
  );
};

export default UserTable;